export const PLAYSTORE_URL =
  "https://play.google.com/store/apps/details?id=com.hydronamics.paywater&pcampaignid=web_share";
export const PAGE_SIZE = 50;

export const cubicMetres = "m³";
